// extracted by mini-css-extract-plugin
export default {"heading":"MainPage_heading__dJEQs","text":"MainPage_text__0D2tv","editor":"MainPage_editor__lJNN3","copy":"MainPage_copy__o3D56","copyButton":"MainPage_copyButton__7FSCX"};